import { EXECUTION_TEMPLATE } from "./execution-brief-template.enum";

export function getExecutionBriefTemplateName(template?: EXECUTION_TEMPLATE): string {
  switch (template) {
    case EXECUTION_TEMPLATE.INSTORE_DIGITAL:
      return "In-Store Digital";
    case EXECUTION_TEMPLATE.INSTORE_PRINT:
      return "In-Store Print";
    case EXECUTION_TEMPLATE.WEB:
      return "Web Banner";
    case EXECUTION_TEMPLATE.SIMPLE:
      return "Simple";
    case EXECUTION_TEMPLATE.EDM:
      return "General";
    case EXECUTION_TEMPLATE.PAID_MEDIA:
      return "Paid Media";
    case EXECUTION_TEMPLATE.DEALER_ADVERTISING:
    default:
      return "Branch";
  }
}
